
import logo from '../images/MintHound.png';

export default function Main() {
    return (
        <>
<section className="h-screen bg-teal-700">
  <div className="flex w-full items-center justify-center container mx-auto px-8 pt-10">
    <div className="max-w-2xl text-center">
      <img src={logo} alt="" />

      <p className="mt-6 lg:text-lg text-white">Stalk all the wallets that you want!</p>

      <div className="mt-8 flex flex-col space-y-3 sm:-mx-2 sm:flex-row sm:justify-center sm:space-y-0">
        <input type="text" className="w-600 rounded-md border border-transparent bg-white/20 px-4 py-2 text-white placeholder-white backdrop-blur-sm focus:border-blue-400 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-40 sm:mx-2" placeholder="Enter ETH address" />

        <button className="transform rounded-md bg-teal-200 px-8 py-2 text-sm font-bold capitalize tracking-wide text-teal-800 transition-colors duration-200 hover:bg-teal-500 focus:bg-teal-500 focus:outline-none sm:mx-2">SNIFF IT OUT</button>
      </div>
    </div>
  </div>
</section>
<h1>hi</h1>
</>
    )}